import LeaderboardExplainer from "../components/schoolfeed/leaderboard/LeaderboardExplainer";
import Leaderboard from "../components/schoolfeed/leaderboard/Leaderboard";
import styles from "./styles/LeaderboardPage.module.scss";
import classNames from "classnames";

export default function LeaderboardPage(props) {

    const containerClassName = classNames({
        [styles.container]: true,
        [styles.staticPageMargin]: true,
    })

    return <div className={containerClassName}>
        <LeaderboardExplainer />
        <Leaderboard />
    </div>
}
